import { render, staticRenderFns } from "./recuperar_pass.vue?vue&type=template&id=4ccff02a"
import script from "./recuperar_pass.vue?vue&type=script&lang=js"
export * from "./recuperar_pass.vue?vue&type=script&lang=js"
import style0 from "./recuperar_pass.vue?vue&type=style&index=0&id=4ccff02a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports